// extracted by mini-css-extract-plugin
export default {"wrapper":"InputWrapper_wrapper__zMl9h","label":"InputWrapper_label__k5XMh"};